import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=ef85054c&scoped=true&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=ef85054c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef85054c",
  null
  
)

export default component.exports